module.exports = __webpack_public_path__ + "img/thumbnail_LittlePenguin_j_normal.5267dbcd.png";